angular.module('wbDashboard').controller('PlansDetailFeatureWiseharvestingControllerAurea', ['$scope', '$uibModal', 'NgTableParams', function ($scope, $uibModal, NgTableParams) {
    $scope.taxableAccount = false;

    /*jshint -W030 */
    $scope.localData || ($scope.localData = {});
    /*jshint +W030 */

    $scope.$watch('whData', function(whData) {
        if (whData) {

            //format data
            var whTableData = [];
            angular.forEach(whData.activity, function(activity) {
                if (activity.amount) {
                    //filter out amount==0
                    activity.dateObj = new Date(activity.date.replace(/-/g, "/"));
                    whTableData.push(activity);
                }
            });

            $scope.whActivityTable = new NgTableParams({
                // initial sort order
                count: 15,
                sorting: {dateObj: "desc"}
            }, {
                counts: [],
                dataset: whTableData
            });
        }
    });

    $scope.$watch('overview', function(overview) {
        if (overview) {
            $scope.taxableAccount = false;
            angular.forEach(overview.account_overview, function(account) {
                if (!account.is_ira && account.type !== 'UTMA') {
                    //PIA, Joint, Trust all count
                    $scope.taxableAccount = true;
                }
            });
            if ($scope.setFeatureTabs) {
                $scope.setFeatureTabs();
            }
        }
    });

    var originalInitialTab = $scope.localData.initialTab;
    $scope.localData.initialTab = function () {
        if ($scope.taxableAccount === false && !$scope.feature.enabled) {
            return "detail";
        } else {
            return originalInitialTab();
        }
    };
    var originalHideDetail = $scope.localData.hideDetail;
    $scope.localData.hideDetail = function () {
        if ($scope.taxableAccount === false && !$scope.feature.enabled) {
            return false;
        } else {
            return originalHideDetail();
        }
    };

    $scope.toggleFeature.onMessage = "Harvesting losses and taking names.";
    $scope.toggleFeature.offMessage = "You can turn this back on at any time.";

}]);
